<template>
  <div class="osclaims-container" ref="container" :class="{ mobile: isMobile }">
    <div class="osclaims-layout">
      <!-- Left Panel -->
      <vue-resizable
        v-show="!isMobile || (isMobile && showLeftPanel)"
        class="left-panel"
        :class="{ 'full-width': isMobile && showLeftPanel }"
        :style="{ flex: leftFlex }"
        :min-width="!isMobile ? 120 : null"
        :max-width="!isMobile ? 300 : null"
      >
        <ConversationLeftPanel @changePanel="togglePanel" />
      </vue-resizable>

      <!-- Divider between Left and Center -->
      <div v-show="!isMobile" class="divider" ></div>

      <!-- Center Panel -->
<div
   class="center-panel"
   :class="{ 'full-width': isMobile }"
   :style="{ flex: centerFlex }"
>

        <ConversationCentralPanel v-touch="{ right: goLeftPanel }" />
      </div>

      <!-- Divider between Center and Right -->
      <div v-show="!isMobile" class="divider" @mousedown="startDraggingRight"></div>

      <!-- Right Panel -->
      <div
        class="right-panel"
        :class="{ open: showconvorightpanel, closed: !showconvorightpanel }"
        :style="{ flex: rightFlexValue }"
      >
        <v-icon
          v-if="!showRightPanel"
          size="30"
          color="green"
          class="open-chat-icon"
          @click="showallthreadconvo()"
        >
          mdi-chat
        </v-icon>
     <v-icon v-if="showRightPanel" @click="openRightPanel(false)">
  mdi-arrow-left
</v-icon>

        <ConversationRightPanel v-show="showRightPanel" />
      </div>
    </div>
  </div>
</template>

<script>
import VueResizable from 'vue-resizable';
import ConversationCentralPanel from "./CenterPanel.vue";
import ConversationLeftPanel from "./LeftPanel.vue";
import ConversationRightPanel from "./Rightpanel/RightPanel.vue";
import { mapGetters, mapMutations, mapActions } from "vuex";
import EventBus from "@/eventBus";
import router from "@/router";
import { Capacitor } from '@capacitor/core';
import { setCustomBackHandler, clearCustomBackHandler, useDefaultBackHandler } from '@/backButtonManager';
import eventBus from '../../eventBus';

export default {
  name: 'Conversation',
  components: {
    VueResizable,
    ConversationCentralPanel,
    ConversationLeftPanel,
    ConversationRightPanel,
  },
  data() {
    return {
      showLeftPanel: true,
      showCenterPanel: true,

      isDraggingLeft: false,
      isDraggingRight: false,
      leftFlex: 2.2,
      centerFlex: 9,
      rightFlex: 6,
      startX: 0,
      rightClosedFlex: 0.5,  
      rightOpenFlex: 6,
    };
  },
  computed: {
    ...mapGetters("osclaims", ["loading"]),
    ...mapGetters("window", ["isMobile"]),
     ...mapGetters("threadconvo",["showconvorightpanel"]),
rightFlexValue() {
  return this.showconvorightpanel ? this.rightOpenFlex : this.rightClosedFlex;
},
  showRightPanel() {
    return this.showconvorightpanel;
  }


  },
  watch: {
    showLeftPanel(newVal) {
      this.showBottomNav(newVal);
    },
  },
  methods: {
    ...mapMutations("osclaims", ["changeLoading", "changeClaim"]),
    ...mapActions("osclaims", ["retrieveClaims"]),
    ...mapMutations("window", ["showBottomNav"]),
    ...mapMutations("threadconvo", ["SHOWCONVORIGHTPANEL","SET_THREAD_FILTER"]),


    togglePanel() {
      if (this.isMobile) {
        this.showLeftPanel = !this.showLeftPanel;
        this.showCenterPanel = !this.showCenterPanel;
      }
    },

    goLeftPanel() {
      if (!this.showLeftPanel) {
        this.showLeftPanel = true;
        if (this.isMobile) {
          this.showCenterPanel = false;
        }
      }
    },

   openRightPanel(value) {
  this.SHOWCONVORIGHTPANEL(value);
},

async showallthreadconvo() {
  try {
    this.SET_THREAD_FILTER(null);
    eventBus.$emit("showthreadconvos");
    this.openRightPanel(true);
  } catch (error) {
    console.error("Failed to fetch thread conversations:", error);
  }
},



    onDragLeft(event) {
      if (!this.isDraggingLeft) return;
      const deltaX = event.clientX - this.startX;
      const totalFlex = this.leftFlex + this.centerFlex + this.rightFlex;
      const containerWidth = this.$refs.container.offsetWidth;
      const deltaFlex = (deltaX / containerWidth) * totalFlex;

      this.leftFlex = Math.max(1, Math.min(totalFlex - 2, this.leftFlex + deltaFlex));
      this.adjustCenterFlex();
      this.startX = event.clientX;
    },
    startDraggingRight(event) {
      this.isDraggingRight = true;
      this.startX = event.clientX;
      document.addEventListener("mousemove", this.onDragRight);
      document.addEventListener("mouseup", this.stopDragging);
    },
    onDragRight(event) {
      if (!this.isDraggingRight) return;
      const deltaX = this.startX - event.clientX;
      const totalFlex = this.leftFlex + this.centerFlex + this.rightFlex;
      const containerWidth = this.$refs.container.offsetWidth;
      const deltaFlex = (deltaX / containerWidth) * totalFlex;

      if (this.showRightPanel) {
        this.rightOpenFlex = Math.max(2, Math.min(10, this.rightOpenFlex + deltaFlex));
      } else {
        this.rightClosedFlex = Math.max(0.3, Math.min(2, this.rightClosedFlex + deltaFlex));
      }

      this.adjustCenterFlex();
      this.startX = event.clientX;
    },
    stopDragging() {
      this.isDraggingLeft = false;
      this.isDraggingRight = false;
      document.removeEventListener("mousemove", this.onDragLeft);
      document.removeEventListener("mousemove", this.onDragRight);
      document.removeEventListener("mouseup", this.stopDragging);
    },
    adjustCenterFlex() {
      const totalFlex = this.leftFlex + this.centerFlex + this.rightFlex;
      this.centerFlex = totalFlex - this.leftFlex - this.rightFlex;
    },
  },

  mounted() {
    if (Capacitor.getPlatform() === 'android') {
      setCustomBackHandler(() => {
        if (!this.showLeftPanel) {
          this.goLeftPanel();
        } else {
          useDefaultBackHandler(router);
        }
      });
    }

    EventBus.$on("back-to-convoLeft", this.togglePanel);
   },

  created() {
    if (this.loading) {
      this.retrieveClaims()
        .catch((err) => console.error(err))
        .finally(() => this.changeLoading(false));
    }
  },

  beforeUnmount() {
    this.changeClaim({});
    clearCustomBackHandler();
    this.openRightPanel(false);
  },
};
</script>

<style scoped>
.osclaims-container {
  display: flex;
  height: 100%;
  width: 100%;
}

.osclaims-layout {
  display: flex;
  height: 100%;
  width: 100%;
}

.left-panel {
  flex: 2;
  transition: all 0.3s ease;
}

.center-panel {
  flex: 8;
  transition: all 0.3s ease;
}

.right-panel {
  position: relative;
  transition: all 0.4s ease;
  overflow: hidden;
}

.right-panel.closed {
  max-width: 80px; 
  min-width: 40px;
  flex: var(--right-closed-flex, 0.5);
}

.right-panel.open {
  max-width: var(--right-open-max, 600px);
  flex: var(--right-open-flex, 6);
}

:root {
  --right-closed-flex: 0.5;
  --right-open-flex: 6;
  --right-open-max: 600px;
}

.open-chat-icon {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}

.divider {
  width: 2px;
  background-color: #ccc;
  cursor: ew-resize;
  transition: background-color 0.2s ease, width 0.2s ease;
}
.divider:hover {
  background-color: #007bff;
  width: 4px;
}

.osclaims-container.mobile,
.osclaims-layout.mobile {
  flex-direction: column;
}

.full-width {
  width: 100%;
  flex: 1 !important;
}

.left-panel,
.center-panel,
.right-panel {
  background-color: #fff;
  box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.1);
}
</style>
